import type { RefObject } from 'react'

export interface IKnapWidgetContainerProps {
  containerRef: RefObject<HTMLDivElement>
}

export const KnapWidgetContainer = ({
  containerRef,
}: IKnapWidgetContainerProps): JSX.Element => (
  <div
    ref={containerRef}
    id="knapsack-widget"
    data-testid="knapsack-widget"
    className="min-h-0 flex-1"
  />
)
